import { useEffect } from 'react';
import debounce from 'lodash/debounce';
import { MAIN_CONTENT_ID, HEADER_ID } from '../constants/ids-constants';

// prefix to avoid conflict with the elements in the DOM (prevent default scroll element into view behavior)
export const HASH_PREFIX = '#see-';
const MARGIN = 15;

let cancel;

export const scrollToElement = (targetElement, behavior = 'smooth') => {
  const header = document.getElementById(HEADER_ID);
  if (targetElement) {
    window.scrollTo({
      top: targetElement.offsetTop - (header?.offsetHeight || 0) - MARGIN,
      behavior
    });
  }
};

const scrollToHash = debounce(() => {
  const { hash } = window.location;
  if (hash) {
    const element = document.getElementById(hash.replace(HASH_PREFIX, ''));
    scrollToElement(element);
  }
  if (cancel) {
    cancel();
  }
}, 1000);

const useScrollToHash = () => {
  useEffect(() => {
    const mainContentElement = document.getElementById(MAIN_CONTENT_ID);
    if (!window.location.hash || !mainContentElement) {
      return;
    }

    const resizeObserver = new ResizeObserver(scrollToHash);

    cancel = () => {
      scrollToHash.cancel();
      resizeObserver.unobserve(mainContentElement);
    };

    resizeObserver.observe(mainContentElement);

    // eslint-disable-next-line consistent-return
    return cancel;
  }, []);
};

export default useScrollToHash;
